export default __webpack_public_path__ + "static/media/close.4800d75f.svg";